import { ICheckItem, IChecklistItemRow, IStampSettings, TChecklistItemStatus } from "@mctypes/checklist.types";
import { IMinUserDepricated } from "@mctypes/global.types";
import moment from "moment/moment";
import * as R from "ramda";
import React, { useEffect, useState } from "react";
import { Button, Input, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import { HSpace, VSpace } from "../../../components";
import Avatar from "../../../components/Avatar";
import { useAppSelector } from "../../../hooks";
import InitialsAndDate from "./InitialsAndDate";

const StampCheck: React.FC<{
  disabled?: boolean;
  toggle: (rowId: string, oldValue: TChecklistItemStatus, newValue: TChecklistItemStatus) => void;
  updateCommentText?: (text: string) => void;
  checkItem: ICheckItem;
  row: IChecklistItemRow;
  stampSettings: IStampSettings;
  includeIr?: boolean;
  includeIrOnDefaultRoles?: boolean;
  includeUavOnDefaultRoles?: boolean;
  templateMode?: boolean;
  includeDisabled?: boolean;
  statusDisabled?: boolean;
}> = ({
  disabled,
  toggle,
  updateCommentText,
  checkItem,
  row,
  stampSettings,
  includeIr = false,
  includeIrOnDefaultRoles,
  includeUavOnDefaultRoles,
  templateMode,
  includeDisabled = false,
  statusDisabled = false,
}) => {
  const handleOnChange = (status: TChecklistItemStatus) => {
    toggle(row._id, checkItem.status, status);
  };

  const [commentModalOpen, setCommentModalOpen] = useState<boolean>(false);
  const user = useAppSelector((state) => state.globalReducer.user);

  const updatedBy = checkItem.updatedBy as IMinUserDepricated;
  // checkItem is null when N/A is set from template
  const hideComment =
    checkItem.status === "N/A" ||
    checkItem.updatedBy === null ||
    (checkItem.comment?.text === "" && updatedBy?._id !== user?._id);

  const onSaveComment = (text: string) => {
    updateCommentText(text);
    setCommentModalOpen(false);
  };

  return (
    <>
      {commentModalOpen === true && (
        <StampCheckModal
          onSaveCommentText={onSaveComment}
          checkItem={checkItem}
          toggle={() => setCommentModalOpen(false)}
        />
      )}
      {checkItem ? (
        row.originalItem != null && (
          <div className="align-items-center" style={{ display: disabled === true ? "none" : "flex" }}>
            {templateMode !== true && (
              <>
                <div
                  className="d-flex align-items-center justify-content-center"
                  onClick={() => disabled === false && handleOnChange(checkItem.status === "NO" ? "N/A" : "NO")}
                  style={{
                    color: "#fff",
                    cursor: disabled ? "cursor" : "pointer",
                    width: "25px",
                    height: "25px",
                    borderRadius: "50%",
                    backgroundColor: checkItem.status === "NO" ? stampSettings.no?.color : "#ccc",
                  }}
                >
                  <i className={`fa fa-${stampSettings.no.icon}`} />
                </div>
                <HSpace />
                <div
                  className="d-flex align-items-center justify-content-center"
                  onClick={() => disabled === false && handleOnChange(checkItem.status === "YES" ? "N/A" : "YES")}
                  style={{
                    color: "#fff",
                    cursor: disabled ? "cursor" : "pointer",
                    width: "25px",
                    height: "25px",
                    borderRadius: "50%",
                    backgroundColor: checkItem.status === "YES" ? stampSettings.yes?.color : "#ccc",
                  }}
                >
                  <i className={`fa fa-${stampSettings.yes.icon}`} />
                </div>
                {includeUavOnDefaultRoles === true && (
                  <>
                    <HSpace />
                    <div
                      className="d-flex align-items-center justify-content-center"
                      onClick={() => disabled === false && handleOnChange(checkItem.status === "UAV" ? "N/A" : "UAV")}
                      style={{
                        color: "#fff",
                        cursor: disabled ? "cursor" : "pointer",
                        width: "25px",
                        height: "25px",
                        borderRadius: "50%",
                        backgroundColor: checkItem.status === "UAV" ? stampSettings.uav.color : "#ccc",
                      }}
                    >
                      <i className={`fa fa-${stampSettings.uav.icon}`} />
                    </div>
                  </>
                )}
              </>
            )}
            {(includeIr === true || includeIrOnDefaultRoles === true) && (
              <>
                <HSpace />
                <div
                  className="d-flex align-items-center justify-content-center"
                  onClick={() => disabled === false && handleOnChange(checkItem.status === "IR" ? "N/A" : "IR")}
                  style={{
                    color: "#fff",
                    cursor: disabled ? "cursor" : "pointer",
                    width: "25px",
                    height: "25px",
                    borderRadius: "50%",
                    backgroundColor: checkItem.status === "IR" ? stampSettings.ir?.color : "#ccc",
                  }}
                >
                  <i className={`fa fa-${stampSettings.ir?.icon}`} />
                </div>
              </>
            )}
            {includeDisabled === true && (
              <>
                <HSpace />
                <div
                  className="d-flex align-items-center justify-content-center"
                  onClick={() =>
                    disabled === false && handleOnChange(checkItem.status === "DISABLED" ? "N/A" : "DISABLED")
                  }
                  style={{
                    color: "#fff",
                    cursor: disabled ? "cursor" : "pointer",
                    width: "25px",
                    height: "25px",
                    borderRadius: "50%",
                    backgroundColor: checkItem.status === "DISABLED" ? "#dc3545" : "#ccc",
                  }}
                >
                  <i className="fa fa-times" />
                </div>
              </>
            )}
            {statusDisabled === false && (
              <>
                <HSpace />
                <div className="d-flex flex-column small-text overflow-hidden" style={{ height: "30px" }}>
                  {checkItem.status !== "N/A" && (
                    <InitialsAndDate updatedBy={checkItem.updatedBy} updatedDate={checkItem.updatedDate} />
                  )}
                </div>
              </>
            )}
            {hideComment === false && statusDisabled === false && (
              <>
                <HSpace />
                <div
                  className="d-flex align-items-center justify-content-center"
                  onClick={() => setCommentModalOpen(true)}
                  style={{
                    color: "#fff",
                    cursor: disabled ? "cursor" : "pointer",
                    width: "25px",
                    height: "25px",
                    borderRadius: "50%",
                    backgroundColor: checkItem.comment?.text?.length > 0 ? "#007bff" : "#ccc",
                  }}
                >
                  <i className={`fa fa-comment`} />
                </div>
              </>
            )}
          </div>
        )
      ) : (
        <div>{JSON.stringify(checkItem)}</div>
      )}
    </>
  );
};

export default StampCheck;

const StampCheckModal: React.FC<{
  toggle: () => void;
  checkItem: ICheckItem;
  onSaveCommentText: (text: string) => void;
}> = ({ toggle, checkItem, onSaveCommentText }) => {
  if (checkItem == null) {
    return null;
  }

  const [text, setText] = useState<string | null>(null);

  const user = useAppSelector((state) => state.globalReducer.user);

  const userIsSameWhoUpdatedCheckItem = user._id === (checkItem.updatedBy as IMinUserDepricated)?._id;

  useEffect(() => {
    setText(R.clone(checkItem.comment?.text) || "");
  }, [checkItem.comment?.text]);

  const comment = checkItem.comment;

  const saveDisabled = text === checkItem.comment?.text;

  return (
    <Modal isOpen toggle={toggle}>
      <ModalHeader toggle={() => toggle()}>Angi kommentar</ModalHeader>
      <ModalBody>
        {comment?.text?.length > 0 && (
          <div className="d-flex align-content-center">
            <Avatar
              id={(comment.createdBy as IMinUserDepricated)?._id}
              name={(comment.createdBy as IMinUserDepricated)?.name}
            />
            <h5 className="gray-800-text mt-1">
              <b className="mr-2">{(comment.createdBy as IMinUserDepricated)?.name}</b>
            </h5>
            <div className="flex-fill" />
            <span>{moment(comment.createdDate).format("YYYY.MM.DD - HH:mm")}</span>
          </div>
        )}
        <VSpace />
        {userIsSameWhoUpdatedCheckItem && (
          <Input type="textarea" value={text} onChange={(e) => setText(e.target.value)} />
        )}
        {userIsSameWhoUpdatedCheckItem === false && <div>{checkItem.comment?.text}</div>}
      </ModalBody>
      <ModalFooter>
        {userIsSameWhoUpdatedCheckItem === true && (
          <Button color="success" disabled={saveDisabled} onClick={() => onSaveCommentText(text)}>
            <i className="fa fa-save fa-fw" />
            Lagre
          </Button>
        )}
      </ModalFooter>
    </Modal>
  );
};
